import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "projects/ert/src/environments/environment";
import { Observable } from "rxjs";
import { IFacilityData } from "../../../interfaces/administration/facilityData";
import { FormGroup } from "@angular/forms";

@Injectable({
  providedIn: "root",
})
export class FacilityService {
  private apiUrl = environment.apiUrl + "/facilities";
  constructor(private http: HttpClient) {}

  public getFacilities(): Observable<IFacilityData[]> {
    return this.http.get<IFacilityData[]>(`${this.apiUrl}`);
  }

  public getFacility(id: any): Observable<IFacilityData> {
    return this.http.get<IFacilityData>(`${this.apiUrl}/${id}`);
  }

  public getFacilityByEntraName(entraName: string): Observable<IFacilityData> {
    return this.http.get<IFacilityData>(`${this.apiUrl}/byEntra/${entraName}`);
  }

  public createFacility(facility: IFacilityData): Observable<IFacilityData> {
    return this.http.post<IFacilityData>(`${this.apiUrl}`, facility);
  }

  public editFacility(facility: IFacilityData): Observable<IFacilityData> {
    return this.http.put<IFacilityData>(
      `${this.apiUrl}/${facility.id}`,
      facility
    );
  }

  public deteleFacility(id: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.apiUrl}/${id}`);
  }

  public validate(form: FormGroup): string[] {
    const errors: string[] = [];
    if (!form.get("name")?.value) {
      errors.push("Name is required");
    }
    return errors;
  }
}
